import {
  Flex,
  Icon,
  LinkAnchor,
  Notification,
  NotificationProps,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useProposalFormData } from '../../../hooks/adjustments/proposal'
import { useEditProposalCallback } from '../../../hooks/proposal'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { getPromotionDisclosureConfig } from '../../../state/configuration'
import { isValidInputs } from '../../formBuilder'
import { useProduct } from '../../product/productContext'
import { useProposal } from '../../product/proposal/proposalContext'

const tKey = TKey('components.promotion-notification')

export interface PromotionNotificationProps extends NotificationProps {
  promoCode: string
}

export const PromotionNotification: FunctionComponent<PromotionNotificationProps> = ({
  promoCode,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { proposal } = useProposal()

  const onReviewAnswers = useEditProposalCallback(proposal)

  const promoDisclosure = getPromotionDisclosureConfig(product)

  const inputs = promoDisclosure?.promotions?.[promoCode]?.inputs ?? []

  const promoData = useProposalFormData(inputs)

  const isValid = isValidInputs(inputs, promoData)

  const variant = isValid ? 'critical' : 'warning'

  return (
    <Notification
      variant={variant}
      type='standalone'
      flexDirection={['column', 'column', 'row']}
      alignItems={['flex-start', 'flex-start', 'center']}
      {...props}
    >
      <Flex justifyContent='flex-start' mr={[0, 0, 2]} mb={[4, 4, 0]}>
        <Icon display={['none', 'none', 'block']} icon='warning' mr={3} />
        <Typo>{t(tKey(variant, promoCode, 'notification'))}</Typo>
      </Flex>
      <LinkAnchor variant='standalone' onClick={onReviewAnswers} typoSize='sm'>
        {t(tKey('actions', 'review'))}
      </LinkAnchor>
    </Notification>
  )
}
